<div class="tarefas-relatos-container">
  <div class="tarefas-tabs">
    <button [class.active]="filtroAtividade === 'tudo'" (click)="filtroAtividade = 'tudo'" type="button">Tudo</button>
    <button [class.active]="filtroAtividade === 'tarefa'" (click)="filtroAtividade = 'tarefa'" type="button">Tarefas</button>
    <button [class.active]="filtroAtividade === 'relato'" (click)="filtroAtividade = 'relato'" type="button">Relatos</button>
  </div>

  <div class="tarefas-lista" [class.tarefas-lista-scroll]="tarefasFiltradas.length > 10" *ngIf="tarefasFiltradas.length > 0; else vazioMsg">
    <div *ngFor="let tarefa of tarefasFiltradas" class="tarefa-item" [class.relato]="tarefa.tipo === 'relato'" [class.concluida]="tarefa.status === 3" [class.excluida]="tarefa.status === 4">
      <div class="tarefa-linha">
        <div class="tarefa-marcador"></div>
        <div class="tarefa-conteudo">
          <span class="tarefa-data">{{ tarefa.dataExibicao }}</span>
          <strong class="tarefa-titulo">{{ tarefa.titulo }}</strong>
          <p class="tarefa-descricao" *ngIf="tarefa.descricao">{{ tarefa.descricao }}</p>
          <span class="tarefa-status" *ngIf="getStatusDescription(tarefa)">{{ getStatusDescription(tarefa) }}</span>
          <p class="tarefa-autor">{{ tarefa.tipo === 'relato' ? 'Relato de ' : 'Tarefa criada por ' }} {{ tarefa.autor }}</p>
        </div>

        <div class="tarefa-acoes" *ngIf="tarefa.status !== 4">
          <button *ngIf="tarefa.tipo === 'tarefa'" type="button" class="acao-btn" [disabled]="somenteLeitura" (click)="concluirTarefa(tarefa)" title="Concluir tarefa">
            <mat-icon class="acao-icone" fontSet="material-symbols-outlined">check</mat-icon>
          </button>
          <button type="button" class="acao-btn" [disabled]="somenteLeitura" (click)="tarefa.tipo === 'relato' ? onEditarRelato(tarefa) : editarTarefa(tarefa)" title="Editar">
            <mat-icon class="acao-icone" fontSet="material-symbols-outlined">edit</mat-icon>
          </button>
          <button type="button" class="acao-btn" [disabled]="somenteLeitura" (click)="tarefa.tipo === 'relato' ? onDeletarRelato(tarefa) : onDeletarTarefa(tarefa)" title="Excluir">
            <mat-icon class="acao-icone" fontSet="material-symbols-outlined">delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-template #vazioMsg>
    <div class="tarefas-relatos-vazio-msg">
      <mat-icon class="vazio-icone" fontSet="material-symbols-outlined">inbox</mat-icon>
      <p class="vazio-titulo">Nenhuma atividade por aqui</p>
      <p class="vazio-texto">Comece adicionando uma tarefa ou relato para acompanhar esta obra!</p>
    </div>
  </ng-template>
</div>
